import { createSelector } from 'reselect'

const getStudentViewData = state => state.student
const getSlideId = (state, slide_uid) => slide_uid

const getStudentSubmitData = createSelector(
	[ getStudentViewData, getSlideId ],
	(student, slideId) => {
		const slide_data = student.slides[slideId]
		const answers = slide_data.answers
		const options = slide_data.options
		const submit_answers = options.reduce((accumulator, item) => {
			accumulator[item.key] = answers.indexOf(item.key) !== -1 ? '1' : '0'
			return accumulator
		}, {})
		return {
			answers: submit_answers,
			device_uid: student.device_uid,
			headers: student.headers,
		}
	}
)

export default getStudentSubmitData
